class CollectionCategoryIconsSlider extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.collection-category-icons__list');
    this.progressFill = this.querySelector('.collection-category-icons__progress-fill');

    if (!this.list || !this.progressFill) return;

    this.onScroll = this.updateProgress.bind(this);
    this.list.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(this.onScroll);
    this.resizeObserver.observe(this.list);

    this.updateProgress();
  }

  updateProgress() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const maxScroll = this.list.scrollWidth - this.list.clientWidth;

    if (maxScroll <= 0) {
      this.progressFill.style.width = '100%';
      return;
    }

    const progress = ((this.list.scrollLeft + this.list.clientWidth) / this.list.scrollWidth) * 100;
    this.progressFill.style.width = `${Math.min(100, Math.max(0, progress))}%`;
  }

  disconnectedCallback() {
    this.list?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('collection-category-icons-slider')) {
  customElements.define('collection-category-icons-slider', CollectionCategoryIconsSlider);
}
